// import { MenuItem } from '@chakra-ui/react'
// import { FC, useMemo, useState } from 'react'
// import { GrDocumentCsv } from 'react-icons/gr'

// import useMrpDistribution from '@hook/mrp/use-distribution'
// import useTools from '@hook/shared/use-tools'

// import { parseDistributionMrpData } from '@helper/grid/mrp/distribution'

// import { ILayoutToolsExportAction } from '@base/@types/components/Layout/Tools'

// const ActionExcelDistributionMroExport: FC<ILayoutToolsExportAction> = ({
//   headers,
//   data,
//   parser = parseDistributionMrpData
// }) => {
//   const { isDisabled } = useTools()
//   const { exportData } = useMrpDistribution()
//   const [isLoading, setLoading] = useState(false)
//   const columns = useMemo(() => {
//     const data: any[] = []

//     for (const header of headers!) {
//       if (!header.columns) continue

//       for (const column of header.columns) {
//         if (column.show) {
//           data.push({
//             id: column.id,
//             displayName: `${header.group} - ${column.name}`
//           })
//         }
//       }
//     }

//     return data
//   }, [headers])

//   const rows = useMemo(() => {
//     const newData = data.filter(
//       x => x.estoqueQuantidadeSugerida * x.estoqueFavorConversao > 0
//     )
//     const parsedData = parser(data)

//     const body = []

//     for (const row of parsedData) {
//       const item: any = {}

//       for (const column of columns) {
//         item[column.id] = row[column.id]
//       }

//       body.push(item)
//     }

//     return body
//   }, [columns, data, parser])

//   return (
//     <MenuItem
//       p="2px 12px"
//       fontSize="sm"
//       bgColor="white"
//       _hover={{ bg: 'gray.400' }}
//       isLoading={isLoading}
//       loadingText="Fazendo Download"
//       isDisabled={isDisabled}
//       onClick={() => {
//         exportData()
//         setTimeout(() => {
//           setLoading(false)
//         }, 2000)
//       }}
//       icon={<GrDocumentCsv />}
//     >
//       Exportar para Tabela
//     </MenuItem>
//   )
// }

// export default ActionExcelDistributionMroExport

// import { MenuItem } from '@chakra-ui/react'
// import { FC, useMemo } from 'react'
// import CsvDownloader from 'react-csv-downloader'
// import { GrDocumentCsv } from 'react-icons/gr'

// import useMrpScheduledPurchase from '@hook/mrp/use-scheduled-purchase'
// import useTools from '@hook/shared/use-tools'

// import { parsePurchaseMrpScheduledData } from '@helper/grid/mrp/scheduled-purchase'
// import { parseScheduledPurchaseMrpData } from '@helper/grid/mrp/scheduled-purchase'

// import { ILayoutToolsExportAction } from '@base/@types/components/Layout/Tools'

// const ActionExcelPurshaseProgramedExport: FC<ILayoutToolsExportAction> = ({
//   headers,
//   data,
//   parser = parsePurchaseMrpScheduledData
//   parser = parseScheduledPurchaseMrpData
// }) => {
//   const { isDisabled } = useTools()
//   const { exportData } = useMrpScheduledPurchase()
//   const columns = useMemo(() => {
//     const data: any[] = []

//     for (const header of headers!) {
//       if (!header.columns) continue

//       for (const column of header.columns) {
//         if (column.show) {
//           data.push({
//             id: column.id,
//             displayName: `${header.group} - ${column.name}`
//           })
//         }
//       }
//     }

//     return data
//   }, [headers])

//   const rows = useMemo(() => {
//     const newData = data.filter(
//       x => x.estoqueQuantidadeSugerida * x.estoqueFavorConversao > 0
//     )
//     const parsedData = parser(data)

//     const body = []

//     for (const row of parsedData) {
//       const item: any = {}

//       for (const column of columns) {
//         item[column.id] = row[column.id]
//       }

//       body.push(item)
//     }

//     return body
//   }, [columns, data, parser])
//   return (
//     <CsvDownloader
//       filename={'MRP-Compra-Programada'}
//       columns={columns}
//       datas={rows}
//       separator=";"
//     >
//       <MenuItem
//         p="2px 12px"
//         fontSize="sm"
//         bgColor="white"
//         _hover={{ bg: 'gray.400' }}
//         isDisabled={isDisabled}
//         icon={<GrDocumentCsv />}
//       >
//         Exportar para Tabela
//       </MenuItem>
//     </CsvDownloader>
//   )
// }

// export default ActionExcelPurshaseProgramedExport
import { MenuItem } from '@chakra-ui/react'
import { FC, useCallback, useMemo, useRef, useState } from 'react'
import CsvDownloader from 'react-csv-downloader'
import { GrDocumentCsv } from 'react-icons/gr'
import Swal from 'sweetalert2'
import { useImmer } from 'use-immer'

import useMrpDistribution from '@hook/mrp/use-distribution'
import useTools from '@hook/shared/use-tools'

import { parseDistributionMrpData } from '@helper/grid'

import { ILayoutToolsExportAction } from '@base/@types/components/Layout/Tools'

const ActionExcelDistributionMroExport: FC<ILayoutToolsExportAction> = ({
  headers,
  // eslint-disable-next-line unused-imports/no-unused-vars
  parser = parseDistributionMrpData
}) => {
  const { isDisabled } = useTools()
  const { data } = useMrpDistribution()
  const [, setDisabled] = useState(false)
  const [, updateDataNew] = useImmer<any[]>([])
  const csvDownload = useRef(null)
  const columns = useMemo(() => {
    const data: any[] = []

    for (const header of headers!) {
      if (!header.columns) continue

      for (const column of header.columns) {
        if (column.show) {
          data.push({
            id: column.id,
            displayName: `${header.group} - ${column.name}`
          })
        }
      }
    }

    return data
  }, [headers])

  const rows = useMemo(() => {
    const parsedData = data

    const body = []

    for (const row of parsedData) {
      const item: any = {}

      for (const column of columns) {
        if (column.id === 'compra-desejada') {
          if (/[a-zA-Z]/.test(row[column.id])) {
            item[column.id] = row[column.id].substring(1)
          } else {
            item[column.id] = row[column.id]
          }
        } else if (column.id === 'recomendacao-tipo-alerta') {
          item[column.id] = row[column.id].substring(1)
        } else {
          item[column.id] = row[column.id]
        }
      }

      body.push(item)
    }

    return body
  }, [columns, data])

  const dataFetch = useCallback(async () => {
    try {
      Swal.fire({
        title: 'Exportar dados!',
        html: 'Aguarde um momento<b></b>.',
        timerProgressBar: true,
        timer: 99999,
        didOpen: () => {
          Swal.showLoading()
        }
      })

      updateDataNew(data)
      setDisabled(true)
      Swal.close()
      csvDownload.current.handleClick()
      // await mrp
      //   .getDistributionData({
      //     page: 1,
      //     params: paramsToSend
      //   })
      //   .then(({ data: { data } }) => {
      //     updateDataNew(data)
      //     setDisabled(true)
      //     Swal.close()

      //     csvDownload.current.handleClick()
      //     // downloadCsv(rows, columns, 'OTB - Acompanhamento')
      //   })
      //   .catch(() => {
      //     Swal.close()

      //     setDisabled(false)
      //   })
    } catch (error: any) {
      // const { data } = error.response
      // const message =
      //   data.response?.status === 400
      //     ? data.response?.data?.data[0].message
      //     : 'Ocorreu um problema interno. Tente novamente mais tarde'
      // toast({
      //   title: 'Atenção.',
      //   description: message,
      //   status: 'warning',
      //   duration: 3000,
      //   isClosable: true
      // })
    }
  }, [updateDataNew, data, csvDownload])
  return (
    <>
      {isDisabled ? (
        <>
          <MenuItem
            p="2px 12px"
            fontSize="sm"
            bgColor="white"
            _hover={{ bg: 'gray.400' }}
            isDisabled={isDisabled}
            onClick={dataFetch}
            icon={<GrDocumentCsv />}
          >
            <CsvDownloader
              filename={'Mrp - Distribuicao'}
              columns={columns}
              datas={rows}
              ref={csvDownload}
              text=" Exportar para Tabela"
              separator=";"
              wrapColumnChar='"'
              bom={true}
            ></CsvDownloader>
          </MenuItem>
        </>
      ) : (
        <MenuItem
          p="2px 12px"
          fontSize="sm"
          bgColor="white"
          _hover={{ bg: 'gray.400' }}
          onClick={dataFetch}
          icon={<GrDocumentCsv />}
        >
          <CsvDownloader
            filename={'Mrp - Distribuicao'}
            columns={columns}
            datas={rows}
            ref={csvDownload}
            text=" Exportar para Tabela"
            separator=";"
            wrapColumnChar='"'
            bom={true}
          ></CsvDownloader>
        </MenuItem>
      )}
    </>
  )
}

export default ActionExcelDistributionMroExport
